const Market = [
  {
    id: 0,
    title: "Rank",
    value: "--",
  },
  {
    id: 1,
    title: "Market Cap",
    value: "$? USD",
  },
  {
    id: 2,
    title: "Volume",
    value: "$****K USD",
  },
];

export default Market;
